module.exports = __webpack_public_path__ + "files/fd0249214e5c4c1b7d40a581943941ba.png";